<template>
	<main class="ApArt-MAIN ONLY-CEL" ref="apartFrame" :style="`background-color: ${viewStyle?.menuSideBgColor} !important;`" @click="hideStatusBar(), checkConfirmedDataUsage()" @touchstart="hideStatusBar(), checkConfirmedDataUsage()" @scroll="hideStatusBar(), checkConfirmedDataUsage()">

		<div class="ApArt-load" v-if="firstTime && firstTimeLoadDisplay"><img src="./assets/master-load.gif"/></div>
		<DataUsageWarning v-if="!confirmedDataUsage && view != 'privacy'" @confirmed-data-usage="confirmedDataUsage = true"/>

		<div class="float-btn" ref="floatBtn" v-if="confirmedDataUsage">
			<img src="./assets/search.png" class="search-btn"
				v-if="stylesByView[view]?.search.visible"
				@click="$router.push({ name: 'search' })"
				:style="stylesByView[view]?.search.style"
			/>
			<img src="./assets/menu-outline.png" class="menu-btn"
				v-if="stylesByView[view]?.menu.visible"
				@click="toggleSideMenu(!sideMenuActive)"
				:style="stylesByView[view]?.menu.style"
			/>
		</div>

		<main class="APART" @click="toggleSideMenu(false)">
			<router-view />
		</main>

		<MenuSide :active="sideMenuActive"/>
		<MenuPill
			v-if="!['artworkcard', 'about', 'privacy', 'contact', 'artistfull', 'cookies', 'subscribe', 'login', 'register', 'profile', 'pwa'].includes(view)"
			@click="toggleSideMenu(false)"
		/>

	</main>
	<main class="ONLY-PC"><PcQr/></main>
	
</template>

<script>
import MenuPill from './components/MenuPill.vue';
import MenuSide from './components/MenuSide.vue';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { App } from '@capacitor/app';
import DataUsageWarning from './components/DataUsageWarning.vue';
import PcQr from './components/PcQr.vue';

export default {
	components: {
		MenuSide, MenuPill, DataUsageWarning, PcQr
	},
	name: 'ApArt',
	data(){
		return{
			//view: 'parenthesis', // 'cube' | 'home' | 'artists' | 'search' | 'artworkcard' | 'parenthesis' | 'about' | 'privacy' | 'contact' | 'artistfull'
			firstTime: true,
			firstTimeLoadDisplay: true,
			confirmedDataUsage: false,
			sideMenuActive: false,
			stylesByView: {
				'artists': {
					menu: { style: "filter:invert(0); margin-top:4.5vw; margin-right:1vw;", visible: false },
					search: { style: "filter:invert(0); margin-top:4.5vw;", visible: false },
					menuSideBgColor: "black",
				},
				'search': {
					menu: { style: "filter:invert(1); margin-top:5vw;", visible: false },
					search: { style: "filter:invert(1); margin-top:5vw;", visible: false },
					menuSideBgColor: "black",
				},
				'cube': {
					menu: { style: "filter:invert(0); margin-top:3.5vw;", visible: true },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "#D2D2D2",
				},
				'artworkcard': {
					menu: { style: "filter:invert(0); margin-top:3.5vw;", visible: true },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "white",
				},
				'parenthesis': {
					menu: { style: "filter:invert(1); margin-top:5.75vw;", visible: false },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "black",
				},
				'about': {
					menu: { style: "filter:invert(0); margin-top:3.5vw;", visible: true },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "black",
				},
				'contact' : {
					menu: { style: "filter:invert(0); margin-top:3.5vw;", visible: true },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "black",
				},
				'artistfull' : {
					menu: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "#015AFF",
				},
				'subscribe': {
					menu: { style: "filter:invert(0); margin-top:3.5vw;", visible: true },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "white",
				},
				'login': {
					menu: { style: "filter:invert(0); margin-top:3.5vw;", visible: true },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "white",
				},
				'profile': {
					menu: { style: "filter:invert(0); margin-top:3.5vw;", visible: true },
					search: { style: "filter:invert(0); margin-top:3.5vw;", visible: false },
					menuSideBgColor: "white",
				},
			},
			selectedArtwork: null,
		}
	},
	provide() {
        return {
            vibration: this.vibration,
			vibrationScrollEnd: this.vibrationScrollEnd,
			getBrowserInfo: this.getBrowserInfo,
			toggleSideMenu: this.toggleSideMenu,
        }
    },
	methods: {
		checkConfirmedDataUsage(){
			if (!JSON.parse(localStorage.getItem("userData") || '{}').dataUsageAccepted){
				this.confirmedDataUsage = false;
			}
		},

		toggleSideMenu(mode_){
			const slide = this.$refs.apartFrame;
			const floatBtn = this.$refs.floatBtn;

			console.log(mode_)

			this.sideMenuActive = mode_;
			const isMenu = this.sideMenuActive;

			slide.scrollTo({
				left: isMenu ? slide.scrollWidth : 0,
				behavior: "smooth"
			});
			floatBtn.style.marginRight = isMenu ? (slide.scrollWidth - window.innerWidth)+'px' : 0;
		},

		hideStatusBar(){
			if (Capacitor.isNativePlatform()) {
				StatusBar.hide().catch(() => {})
			}
		},

		vibration(pattern){
			try {
				navigator.vibrate(pattern);
			} catch (error) {
				console.log(error);
			}
		},

		vibrationScrollEnd(e){
			const el = e.target;
            const max = el.scrollHeight - el.clientHeight;
            const percent = max <= 0 ? 100 : (el.scrollTop / max) * 100;
            if(percent <= 0 || percent >= 100) this.vibration(75);
		},

		getBrowserInfo() {
			const ua = navigator.userAgent || "";
			const vendor = navigator.vendor || "";

			const isIOS =
			/iPad|iPhone|iPod/.test(ua) ||
			(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

			const isAndroid = /Android/.test(ua);
			const isMac = !isIOS && /Macintosh/.test(ua);
			const isWindows = /Windows/.test(ua);
			const isLinux = /Linux/.test(ua) && !isAndroid;

			// iOS browsers (apps)
			const isChromeiOS = /CriOS/.test(ua);
			const isFirefoxiOS = /FxiOS/.test(ua);
			const isEdgeiOS = /EdgiOS/.test(ua);
			const isOpiOS = /OPiOS/.test(ua);

			// Desktop/Android browsers
			const isEdge = /Edg\//.test(ua);
			const isOpera = /OPR\//.test(ua) || /Opera/.test(ua);
			const isFirefox = /Firefox\//.test(ua);
			const isChrome = /Chrome\//.test(ua) && !isEdge && !isOpera;
			const isSafari =
			vendor.includes("Apple") &&
			/Safari\//.test(ua) &&
			!isChromeiOS &&
			!isFirefoxiOS &&
			!isEdgeiOS &&
			!isOpiOS &&
			!isChrome &&
			!isEdge &&
			!isOpera &&
			!isFirefox;

			let name = "Unknown";
			if (isIOS) {
				if (isChromeiOS) name = "Chrome (iOS)";
				else if (isFirefoxiOS) name = "Firefox (iOS)";
				else if (isEdgeiOS) name = "Edge (iOS)";
				else if (isOpiOS) name = "Opera (iOS)";
				else if (isSafari) name = "Safari (iOS)";
				else name = "WebKit (iOS)";
			} else {
				if (isEdge) name = "Edge";
				else if (isOpera) name = "Opera";
				else if (isFirefox) name = "Firefox";
				else if (isChrome) name = "Chrome";
				else if (isSafari) name = "Safari";
			}

			let os = "Unknown";
			if (isIOS) os = "iOS";
			else if (isAndroid) os = "Android";
			else if (isMac) os = "macOS";
			else if (isWindows) os = "Windows";
			else if (isLinux) os = "Linux";

			return {
				name,
				os,
				isIOS,
				isAndroid,
				isSafari,
				isChrome,
				isFirefox,
				isEdge,
				ua,
				vendor,
			};
		},

		async applyUpdate() {
			const reg = this._swRegistration
			if (!reg) return

			// intenta activar el waiting SW
			if (reg.waiting) {
				reg.waiting.postMessage({ type: 'SKIP_WAITING' })
			}

			// recarga cuando cambie controller
			navigator.serviceWorker.addEventListener('controllerchange', () => {
				window.location.reload()
			})
		},
	},

	beforeMount() {
		if (!localStorage.getItem("userData")) {
			this.firstTime = true;
			localStorage.setItem("userData", JSON.stringify({}));
		}else{
			this.firstTime = false;
		}

		setTimeout(() => {
			this.firstTimeLoadDisplay = false;
		}, 3_000);

		this.confirmedDataUsage = true;
		if (!JSON.parse(localStorage.getItem("userData") || '{}').dataUsageAccepted) {
			setTimeout(() => {
				this.confirmedDataUsage = false;
			}, 3_000 + 2_000);
		} 
	},

	mounted() {
		// 1) Guarda la ruta que estás dejando (from) en cada navegación
		this._leavingRoute = this.$route

		this._unregAfterEach = this.$router.afterEach((to, from) => {
			this._leavingRoute = from
		})

		// 2) Back del navegador (hash mode): decide usando la ruta "leaving"
		const onPopState = () => {
			if (this.sideMenuActive) {
				this.toggleSideMenu(false)
				this.$router.replace(this.$route.fullPath)
				return
			}

			const leaving = this._leavingRoute || this.$route
			const cur = leaving.name

			console.log('leaving cur', cur);

			if (cur === 'artworkcard') {
				const from = leaving.query?.from;
				if(from === 'profile'){
					return this.$router.replace({ name: 'profile' });
				}
				return this.$router.replace({ name: 'artists' });
			}
			if (cur === 'about' || cur === 'privacy') return this.$router.replace({ name: 'parenthesis' });
			if (cur === 'search') return this.$router.replace({ name: 'artists' });
			if (cur === 'artists') return this.$router.replace({ name: 'parenthesis' });
			if (cur === 'artistfull') {
				const view = leaving.query?.view;
				const id = leaving.params?.id;
				if(view === 'detail')
					return this.$router.replace({ name: 'artistfull', params: { id: String(id) }, query: { view: 'info' } });
				if(view === 'info')
					return this.$router.replace({ name: 'artistfull', params: { id: String(id) }, query: { view: 'cover' } })
				if(view === 'artworks')
					return this.$router.replace({ name: 'artistfull', params: { id: String(id) }, query: { view: 'info' } })
			}

			if (cur === 'contact') {
				const from = leaving.query?.from;
				const id = leaving.params?.id;
				if (from === 'artwork' && id) {
					return this.$router.replace({ name: 'artworkcard', params: { id: String(id) } });
				}
				return this.$router.replace({ name: 'parenthesis' });
			}
		}

		window.addEventListener('popstate', onPopState)
		this._onPopState = onPopState

		// Android hardware back (Capacitor)
		App.addListener('backButton', () => {
			onPopState()
		})

		// escuchar evento de actualización de PWA:
		window.addEventListener('sw-updated', (e) => {
			this._swRegistration = e.detail
			this.showUpdateBanner = true
		})
	},

	beforeUnmount() {
		window.removeEventListener('popstate', this._onPopState)
		if (Capacitor.isNativePlatform()) App.removeAllListeners?.()
	},

	computed: {
		view() {
			return this.$route.name
		},
		viewStyle() {
			const bg = this.stylesByView[this.view]?.menuSideBgColor;
			if(bg) document.body.style.backgroundColor = bg;
			return this.stylesByView[this.view] || {}
		}
	},

}
</script>

<style lang="stylus">
$fonts = "~@/assets/fonts"

// Archivo ExtraCondensed
@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-Light.ttf") format("truetype")
  font-weight 300
  font-style normal
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-LightItalic.ttf") format("truetype")
  font-weight 300
  font-style italic
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-Regular.ttf") format("truetype")
  font-weight 400
  font-style normal
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-Italic.ttf") format("truetype")
  font-weight 400
  font-style italic
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-Medium.ttf") format("truetype")
  font-weight 500
  font-style normal
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-MediumItalic.ttf") format("truetype")
  font-weight 500
  font-style italic
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-SemiBold.ttf") format("truetype")
  font-weight 600
  font-style normal
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-SemiBoldItalic.ttf") format("truetype")
  font-weight 600
  font-style italic
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-Bold.ttf") format("truetype")
  font-weight 700
  font-style normal
  font-display swap

@font-face
  font-family "Archivo ExtraCondensed"
  src url($fonts + "/01-Archivo-ExtraCondensed-[Titulos]/Archivo_ExtraCondensed-BoldItalic.ttf") format("truetype")
  font-weight 700
  font-style italic
  font-display swap

// Archivo Condensed
@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-Light.ttf") format("truetype")
  font-weight 300
  font-style normal
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-LightItalic.ttf") format("truetype")
  font-weight 300
  font-style italic
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-Regular.ttf") format("truetype")
  font-weight 400
  font-style normal
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-Italic.ttf") format("truetype")
  font-weight 400
  font-style italic
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-Medium.ttf") format("truetype")
  font-weight 500
  font-style normal
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-MediumItalic.ttf") format("truetype")
  font-weight 500
  font-style italic
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-SemiBold.ttf") format("truetype")
  font-weight 600
  font-style normal
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-SemiBoldItalic.ttf") format("truetype")
  font-weight 600
  font-style italic
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-Bold.ttf") format("truetype")
  font-weight 700
  font-style normal
  font-display swap

@font-face
  font-family "Archivo Condensed"
  src url($fonts + "/02-Archivo-Condensed-[Textos]/Archivo_Condensed-BoldItalic.ttf") format("truetype")
  font-weight 700
  font-style italic
  font-display swap

// DM Mono
@font-face
  font-family "DM Mono"
  src url($fonts + "/03-DM-Mono-[Etiquetas-Subtitulos]/DMMono-Light.ttf") format("truetype")
  font-weight 300
  font-style normal
  font-display swap

@font-face
  font-family "DM Mono"
  src url($fonts + "/03-DM-Mono-[Etiquetas-Subtitulos]/DMMono-LightItalic.ttf") format("truetype")
  font-weight 300
  font-style italic
  font-display swap

@font-face
  font-family "DM Mono"
  src url($fonts + "/03-DM-Mono-[Etiquetas-Subtitulos]/DMMono-Regular.ttf") format("truetype")
  font-weight 400
  font-style normal
  font-display swap

@font-face
  font-family "DM Mono"
  src url($fonts + "/03-DM-Mono-[Etiquetas-Subtitulos]/DMMono-Italic.ttf") format("truetype")
  font-weight 400
  font-style italic
  font-display swap

@font-face
  font-family "DM Mono"
  src url($fonts + "/03-DM-Mono-[Etiquetas-Subtitulos]/DMMono-Medium.ttf") format("truetype")
  font-weight 500
  font-style normal
  font-display swap

@font-face
  font-family "DM Mono"
  src url($fonts + "/03-DM-Mono-[Etiquetas-Subtitulos]/DMMono-MediumItalic.ttf") format("truetype")
  font-weight 500
  font-style italic
  font-display swap

.DISPLAY
	display: flex
	flex-direction: column
	width: 100%
	min-height: 100dvh

.hide-scrollbar
.hide-scrollbar *
	scrollbar-width: none
	-ms-overflow-style: none

	::-webkit-scrollbar
	::-webkit-scrollbar-button
		display: none

*:disabled
	opacity: 0.5

.ONLY-CEL
	display: flex !important

.ONLY-PC
	display: none !important

@media (min-width: 1024px)

	.ONLY-CEL
		display: none !important

	.ONLY-PC
		display: flex !important
</style>

<style scoped lang="stylus">
.ApArt-MAIN
	width: 100
	height: 100dvh
	display: flex
	flex-direction: row
	overflow: hidden

.APART
	width: 100%
	min-width: 100%

.ApArt-load
	position: fixed
	z-index: 4
	top: 0
	left: 0
	width 100%
	height: 100dvh
	display: flex
	align-items: center
	justify-content: center
	background-color: #015aff
	animation-name: apartLoad
	animation-duration: 3s
	animation-fill-mode: forwards
	animation-timing-function: cubic-bezier(0.64, 0, 0.78, 0)

	img
		width: 34vw
		max-width: 360px

@keyframes apartLoad {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}

/* float buttons */
.float-btn
	position: fixed
	right: 5vw
	z-index: 3
	transition: margin-right 0.25s
	display: flex;
	align-items: center

	img
		cursor: pointer

.menu-btn
	max-width: 6vw
	max-height: 6vw

.search-btn
	max-width: 6vw
	max-height: 6vw
	margin-right: 1ch
</style>